import { render, staticRenderFns } from "./CompanyRLSGroupChecklistSaveButton.vue?vue&type=template&id=55103724"
import script from "./CompanyRLSGroupChecklistSaveButton.vue?vue&type=script&lang=js"
export * from "./CompanyRLSGroupChecklistSaveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports